export default __webpack_public_path__ + "images/0x6fb9897896fe5d05025eb43306675727887d0b7c.png";